<template>
  <div
    ref="menu"
    v-if="! $store.getters['settingsModule/elementSidebar']"
    :class="positionClasses"
    class="wf--ml-48 wf-absolute wf-bg-white wf-rounded-lg wf-overflow-hidden wf-border-4 wf-border-white wf-shadow-md wf-w-56 wf-z-50"
  >
    <ul>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="content"
        title="Content"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in contentProperties"
            :key="property.key"
            :is="property.component"
            :text="property.text"
            :property="property.property"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="style"
        title="Style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in styleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :text="property.text"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="titleStyle"
        title="Title Style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in titleStylesProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :text="property.text"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        v-if="parent.content.hasIcon"
        @updateOpen="updateOpen"
        trigger="iconStyles"
        title="Icon Styles"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in iconStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="advanced"
        title="Advanced"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in advancedProperties"
            :key="property.key"
            :is="property.component"
            :element="element"
          ></component>
        </template>
      </EditorElementMenuList>
    </ul>
  </div>
</template>

<script>
  import ElementMenu from '../../contracts/ElementMenu'
  export default ElementMenu.extend({
    data() {
      return {
        open: 'content',
      }
    },
    computed: {
      contentProperties() {
        return this.parent.properties.content
      },
      styleProperties() {
        return this.parent.properties.styles
      },
      iconStyleProperties() {
        return this.parent.properties.iconStyles
      },
      titleStylesProperties() {
        return this.parent.properties.titleStyles
      },
      advancedProperties() {
        return this.parent.properties.advanced
      },
    }
  })
</script>
